import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BottomToolbar from "./BottomToolbar";

/**
 * Global navigation toolbar mounted once at the app root so it appears on
 * every page EXCEPT the Project Workspace and the public landing/register
 * pages. Dashboard has its own wired instance (the "Projects" button there
 * opens the All-Projects dialog), so we also skip /home to avoid duplicates.
 *
 * iter-92c: also injects a body class while the toolbar is rendered so
 * pages reserve ~7rem of bottom padding — without it the last list rows
 * sit under the fixed toolbar and the user can't scroll to them.
 */
export default function GlobalBottomToolbar() {
    const location = useLocation();
    const navigate = useNavigate();

    const path = location.pathname || "";
    const hiddenRoutes = ["/", "/login", "/register", "/home", "/privacy", "/terms", "/reactivate", "/email", "/about", "/portfolio", "/resources", "/contact"];
    const hiddenPrefixes = ["/services"];
    const visible =
        !path.startsWith("/workspace") &&
        !path.startsWith("/q/") &&
        !hiddenPrefixes.some((p) => path.startsWith(p)) &&
        !hiddenRoutes.includes(path);

    useEffect(() => {
        if (!visible) return undefined;
        document.body.classList.add("has-bottom-toolbar");
        return () => document.body.classList.remove("has-bottom-toolbar");
    }, [visible]);

    if (!visible) return null;

    return (
        <BottomToolbar
            onProjects={() => navigate("/projects")}
            onBuildTemplate={() => navigate("/templates")}
            onEmail={() => navigate("/email")}
            onContacts={() => navigate("/contacts")}
            onLeads={() => navigate("/leads")}
            onFiles={() => navigate("/files")}
        />
    );
}
